export default __webpack_public_path__ + "static/media/asset-7.3f8d9257.svg";